export function getComparisonCartWidth(
  comparisonCartLength: number,
  recCardIsInCart: boolean,
  recommendedCard: boolean | undefined,
): string {
  if (!recommendedCard) {
    if (comparisonCartLength === 1) {
      return 'w-full'
    }
    if (comparisonCartLength > 1) {
      return 'sm:w-1/2'
    }
    return ''
  }

  switch (comparisonCartLength) {
    case 1:
      return recCardIsInCart ? 'w-full' : 'sm:w-1/2'
    case 2:
      return recCardIsInCart ? 'sm:w-1/2' : 'sm:w-1/3'
    case 3:
      return recCardIsInCart ? 'sm:w-1/3' : 'sm:w-[31%] sm:shrink-0 lg:w-1/4'
    default:
      return ''
  }
}

export function getCartMenuClass(
  comparisonCartLength: number,
  recCardIsInCart: boolean,
  recommendedCard?: boolean,
): string {
  const firstClass =
    'sm:max-w-[352px] lg:max-w-[404px] xl:max-w-[388px] / sm:px-0 lg:px-8 xl:pl-4'
  const paddingClass = 'sm:px-4 lg:px-8 xl:px-4'

  if (recCardIsInCart || !recommendedCard) {
    if (comparisonCartLength === 1) {
      return firstClass
    }
    if (comparisonCartLength >= 2) {
      return paddingClass
    }
    return ''
  }

  if (comparisonCartLength >= 1) {
    return paddingClass
  }

  return ''
}

export function getRecommendedCardClass(
  comparisonCartLength: number,
  recCardIsInCart: boolean,
  recommendedCard?: boolean,
): string {
  if (!recommendedCard || recCardIsInCart) {
    return 'hidden'
  }
  if (comparisonCartLength === 1) {
    return 'sm:w-1/2'
  }
  if (comparisonCartLength === 2) {
    return 'sm:w-1/3'
  }
  if (comparisonCartLength === 3) {
    return 'sm:w-[31%] sm:shrink-0 lg:w-1/4'
  }
  return ''
}

export function getCardClassByComparisonLength(
  comparisonCartLength: number,
): string {
  switch (comparisonCartLength) {
    case 1:
      return 'card-1 px-2 xxs:px-4 sm:px-8 lg:px-12'
    case 2:
      return 'card-2 px-2 xxs:px-4 md:px-6 lg:px-8'
    default:
      return 'extra px-2 xxs:px-4 sm:px-3 md:px-4 xl:px-5'
  }
}
